import { render, staticRenderFns } from "./Client_Ergo_Eval.vue?vue&type=template&id=2345086c"
import script from "./Client_Ergo_Eval.vue?vue&type=script&lang=js"
export * from "./Client_Ergo_Eval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports